import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ToastState {
  message: string | null
  visible: boolean
  type: 'success' | 'error'
}

const initialState: ToastState = {
  message: null,
  visible: false,
  type: 'success',
}

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (
      state,
      action: PayloadAction<{ message: string; type: 'success' | 'error'; }>
    ) => {
      state.message = action.payload.message
      state.type = action.payload.type
      state.visible = true
    },
    hideToast: (state) => {
      state.visible = false
      state.message = null
    },
  },
})

export const { showToast, hideToast } = toastSlice.actions

const ToastReducer = toastSlice.reducer

export default ToastReducer
